// HM-378 cluster 16.4 BONUS: tech debt cluster 16.1.6 (StepRecap.SummaryRows
// mostrava raw 'mode' es 'day_use_4h'). Mappa label leggibili e durata.

import type { WalkInMode } from '../stores/walkIn.js';

const MODE_LABELS: Record<WalkInMode, string> = {
  day_use_4h: 'Day Use 4 ore',
  day_use_8h: 'Day Use 8 ore',
  overnight: 'Pernottamento',
};

export function formatMode(mode: WalkInMode): string {
  return MODE_LABELS[mode] ?? mode;
}

/**
 * Formatta una scelta dynamic (cluster 16.1) o legacy mode in label
 * leggibile. Preferisce dynamic quando presente.
 */
export function formatModeDynamic(
  legacyMode: WalkInMode,
  dynamic?: { selectedMode: 'hours' | 'overnight'; selectedHours: number },
): string {
  if (dynamic?.selectedMode === 'overnight') return 'Pernottamento';
  if (dynamic?.selectedMode === 'hours') {
    return `Day Use ${dynamic.selectedHours} ${dynamic.selectedHours === 1 ? 'ora' : 'ore'}`;
  }
  return formatMode(legacyMode);
}
